<zaeper-profile-card
  [coverImgUrl]="application.titleImageUrl"
  [profileImgUrl]="application.darkIconUrl"
  [title]="application.name" [hasDynamicWidth]="useDynamicWidth"
  (onClick)="onClick.emit()"
  styleClass="
    relative
    {{styleClass}}
  "
>
  @if(!!actionsTemplate) {
    <div class="absolute top-3 right-3">
      <ng-container [ngTemplateOutlet]="actionsTemplate"></ng-container>
    </div>
  }

  <ng-template zTemplate="header">
    <small>Zaeper GmbH</small>
  </ng-template>

  Version 1.0.0<br/>
  Werkzeug
</zaeper-profile-card>
